export default __webpack_public_path__ + "static/media/stats-empty-placeholder.92bf12d4.jpg";